import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import {
  FETCH_WALLET_CASHOUTS_DATA,
  CREATE_WALLET_CASHOUT_DATA,
  APPROVE_WALLET_CASHOUT_DATA,
  REJECT_WALLET_CASHOUT_DATA,
  COMPLETE_WALLET_CASHOUT_DATA,
  CANCEL_WALLET_CASHOUT_DATA,
} from "./actionTypes";
import {
  fetchWalletCashoutsSuccess,
  fetchWalletCashoutsFailure,
  createWalletCashoutSuccess,
  createWalletCashoutFailure,
  approveWalletCashoutSuccess,
  approveWalletCashoutFailure,
  rejectWalletCashoutSuccess,
  rejectWalletCashoutFailure,
  completeWalletCashoutSuccess,
  completeWalletCashoutFailure,
  cancelWalletCashoutSuccess,
  cancelWalletCashoutFailure,
} from "./actions";

function* fetchWalletCashoutsDataSaga(action) {
  try {
    const filters = action.payload || {};
    let url = process.env.REACT_APP_WEB_APP_URL + `/api/web/wallet-cashout/`;
    
    const queryParams = new URLSearchParams();
    if (filters.status) queryParams.append('status', filters.status);
    if (filters.driver_id) queryParams.append('driver_id', filters.driver_id);
    if (filters.per_page) queryParams.append('per_page', filters.per_page);
    
    if (queryParams.toString()) {
      url += `?${queryParams.toString()}`;
    }

    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    yield put(fetchWalletCashoutsSuccess(response.data));
  } catch (error) {
    yield put(fetchWalletCashoutsFailure(error.response?.data?.message || error.message));
  }
}

function* createWalletCashoutDataSaga(action) {
  try {
    const token = localStorage.getItem("authToken");
    const response = yield call(
      axios.post,
      process.env.REACT_APP_WEB_APP_URL + `/api/wallet-cashout/create-request`,
      action.payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    yield put(createWalletCashoutSuccess(response.data));
  } catch (error) {
    yield put(createWalletCashoutFailure(error.response?.data?.message || error.message));
  }
}

function* approveWalletCashoutDataSaga(action) {
  try {
    const { id, notes } = action.payload;
    const token = localStorage.getItem("authToken");
    const response = yield call(
      axios.post,
      process.env.REACT_APP_WEB_APP_URL + `/api/web/wallet-cashout/approve/${id}`,
      { notes },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    yield put(approveWalletCashoutSuccess(response.data));
  } catch (error) {
    yield put(approveWalletCashoutFailure(error.response?.data?.message || error.message));
  }
}

function* rejectWalletCashoutDataSaga(action) {
  try {
    const { id, rejectionReason, notes } = action.payload;
    const token = localStorage.getItem("authToken");
    const response = yield call(
      axios.post,
      process.env.REACT_APP_WEB_APP_URL + `/api/web/wallet-cashout/reject/${id}`,
      { rejection_reason: rejectionReason, notes },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    yield put(rejectWalletCashoutSuccess(response.data));
  } catch (error) {
    yield put(rejectWalletCashoutFailure(error.response?.data?.message || error.message));
  }
}

function* completeWalletCashoutDataSaga(action) {
  try {
    const { id, notes } = action.payload;
    const token = localStorage.getItem("authToken");
    const response = yield call(
      axios.post,
      process.env.REACT_APP_WEB_APP_URL + `/api/web/wallet-cashout/complete/${id}`,
      { notes },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    yield put(completeWalletCashoutSuccess(response.data));
  } catch (error) {
    yield put(completeWalletCashoutFailure(error.response?.data?.message || error.message));
  }
}

function* cancelWalletCashoutDataSaga(action) {
  try {
    const id = action.payload;
    const token = localStorage.getItem("authToken");
    const response = yield call(
      axios.post,
      process.env.REACT_APP_WEB_APP_URL + `/api/wallet-cashout/cancel/${id}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    yield put(cancelWalletCashoutSuccess(response.data));
  } catch (error) {
    yield put(cancelWalletCashoutFailure(error.response?.data?.message || error.message));
  }
}

export default function* walletCashoutSaga() {
  yield takeEvery(FETCH_WALLET_CASHOUTS_DATA, fetchWalletCashoutsDataSaga);
  yield takeEvery(CREATE_WALLET_CASHOUT_DATA, createWalletCashoutDataSaga);
  yield takeEvery(APPROVE_WALLET_CASHOUT_DATA, approveWalletCashoutDataSaga);
  yield takeEvery(REJECT_WALLET_CASHOUT_DATA, rejectWalletCashoutDataSaga);
  yield takeEvery(COMPLETE_WALLET_CASHOUT_DATA, completeWalletCashoutDataSaga);
  yield takeEvery(CANCEL_WALLET_CASHOUT_DATA, cancelWalletCashoutDataSaga);
}

